const dev = 'http://localhost:5000/scan-opologic/us-central1';
const prod = 'https://us-central1-scan-opologic.cloudfunctions.net';

const apiUrl = process.env.NODE_ENV === 'development' ? dev : prod;

export default apiUrl;
